import WoundType from './WoundType';

export default WoundType;
